import React, { useEffect } from 'react';
import Request from '../../common/Request';
import Common from '../../common/Common';
import Format from '../../common/Format';
import {
  Input,
} from "reactstrap";
import {
  cst_pay_unit_type_day,
  REQUEST_BOX_STATUS,
} from '../../variables/codes_map';
import GoogleDrive from "../../common/GoogleDrive"
/**
 * 調査情報領域詳細
 * 
 * 利用ページ　/survey/ 
 * @param {*} row 
 * @returns 
 */
export function RequestInfoDetail({ data }) {

  const columns = [
    { Header: '現場名/工事番号', accessor: '___JOIN_project_information' },
    { Header: '案件ID', accessor: 'REQUEST__request_natural_id' },
    { Header: '見積提出期限', accessor: 'REQUEST__estimate_deadline' },
    { Header: 'ステータス', accessor: 'REQUEST__survey_status' },
    { Header: '依頼内容', accessor: '___JOIN_request' },
    { Header: '顧客情報', accessor: '___JOIN_client_master' },
    { Header: '顧客情報（下請先）', accessor: '___JOIN_subcontract_customer_information' },
    { Header: '現場名/工事番号', accessor: '___JOIN_project_information' },
    { Header: '現場住所', accessor: '___JOIN_project_addr' },
    { Header: '見積依頼受付日', accessor: 'REQUEST__request_date' },
    { Header: '利用期間', accessor: '___JOIN_REQUEST__want_period_of_use' },
    { Header: '調査担当者', accessor: 'REQUEST__onsite_survey_account' },
    { Header: '顧客からの要望', accessor: 'REQUEST__customer_other_request' },
    { Header: '顧客支店メモ', accessor: 'REQUEST__customer_branch_system_memo' },
    { Header: '顧客への連絡欄', accessor: 'REQUEST__contact_memo' },
    // ボタン
    { Header: '調査', accessor: 'actions_1' },
    { Header: '再見積', accessor: 'actions_2' },
    { Header: '見積編集', accessor: 'actions_3' },
    { Header: 'キャンセル確認', accessor: 'actions_cancel_confirm' },
    { Header: '見積送付', accessor: 'actions_send_estimate' },
    /**feature/1590 顧客システム連携対応 */
    { Header: '添付ファイルダウンロード', accessor: 'actions_customer_request_file' },
    { Header: '見積チェックOK', accessor: 'actions_check_ok_estimate' },
    { Header: '見積チェックNG', accessor: 'actions_check_ng_estimate' },
    { Header: '顧客への連絡事項', accessor: 'actions_contact_memo' },
    
  ];

  const columnsMap = new Map();
  columns.map((column) => columnsMap.set(column.Header, column))

  var columnValue = function (columnsName) {
    return data.original[columnsMap.get(columnsName).accessor]
  }

  var columnName = function (columnsName) {
    return columnsMap.get(columnsName).Header
  }

  // 依頼.依頼BOXステータス = 2:チェックのとき、見積もりの明細を取得する
  const [request_data, setRequestData] = React.useState([]);
  const [request_natural_id, setRequestNaturalId] = React.useState('');
  
  let estimate_status = ''

  function enFormat(str) {
    return Format.comma_delimited(str, "円");
  }

  function resetData() {
    const request_box_status = data.original['REQUEST__request_box_status']
    if (request_box_status === REQUEST_BOX_STATUS.CHECK
      || request_box_status === REQUEST_BOX_STATUS.CHECK_OK
      || request_box_status === REQUEST_BOX_STATUS.CHECK_NG
    ) {
      // 明細データを取得する
      var url = '/api/estimate';
      var request_natural_id = data.original['REQUEST__request_natural_id']
      let params = {
        request_natural_id: request_natural_id
      };

      Request.get(url, params, res => {
        estimate_status = res.data.map((row) => row.estimate_status)
        setRequestData(res.data)
      })
    }
  }

  useEffect(() => {
    resetData()
  }, [request_natural_id])

  useEffect(() => {
    console.log("request_data", request_data)
  }, [request_data])

  const addMemo = data.original['addMemo']
  
  const button_class="MuiButtonBase-root MuiButton-root MuiButton-text btn btn-secondary btn-facebook btn-search margin"

  return <>
    <div class="RequestInfoDetail" >
      <table border="0" cellspacing="0" cellpadding="0" class="RequestInfoDetailTable">
        <tbody>
          <tr>
            <th>{columnName("見積依頼受付日")}</th>
            <td>{columnValue("見積依頼受付日")}</td>
            <th>{columnName("顧客情報（下請先）")}</th>
            <td>{columnValue("顧客情報（下請先）")}</td>
          </tr>
          <tr>
            <th>{columnName("利用期間")}</th>
            <td>{columnValue("利用期間")}</td>
            <th></th>
            {/* <th>{columnName("顧客への連絡欄")}</th> */}
            {/* <td rowspan="2">{columnValue("顧客への連絡欄")}</td> */}
            <td></td>
          </tr>
          <tr>
            <th>{columnName("顧客からの要望")}</th>
            <td>{columnValue("顧客からの要望")}</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <th>{columnName("顧客支店メモ")}</th>
            <td>{columnValue("顧客支店メモ")}</td>
            <th>&nbsp;</th>
            <td></td>
            {/* <td>{columnValue("顧客への連絡事項")}</td> */}
          </tr>
          <tr>
            <th colspan="4" >
              {columnValue("調査")}
              {columnValue("再見積")}
              {columnValue("キャンセル確認")}
              {columnValue("添付ファイルダウンロード")}
              {columnValue("見積チェックOK")}
              {columnValue("見積チェックNG")}
              {columnValue("見積編集")}
              {columnValue("見積送付")}
            </th>
          </tr>
          {request_data.map((row) => {
            // console.log(row)
            // [利益額] = [見積合計] - [仕入合計]
            const profit_amt = row.survey_total_amt - row.survey_cost_total_amt
            // [利益率] = [利益額] / [見積合計] * 100 (%)
            const profit_rate = (profit_amt / row.survey_total_amt * 100).toFixed(2)
            return <>
              <tr class="rt-tr" >
                <td class="estimateDetailRow">
                  {<a href={GoogleDrive.getOpenUrl(row.latest_pdf_survey_url)} target="_blank">{row.estimate_natural_id}</a>}<br />
                  {<a href={GoogleDrive.getOpenUrl(row.latest_pdf_route_url)} target="_blank">経路図</a>}<br />
                  {Format.format_date_range_yymmdd(row.survey_available_start_date, row.survey_available_end_date)}<br />
                  {row.survey_parking_name + "（" + row.survey_capacity_qty + "台）"}<br />
                  日割可否:{Common.getValueFormDictArray(cst_pay_unit_type_day, row.survey_pay_unit_type_day)}<br />
                </td>

                <td>
                  <table>
                    <tr>
                      <td align='left' valign='top'>
                        <br />
                        <span style={{whiteSpace: "nowrap"}}>賃料（月単価）</span><br />
                        礼金<br />
                        手数料<br />
                        その他<br />
                        敷金<br />
                        合計<br />
                        利益額<br />
                        利益率<br />
                      </td>
                      <td align='right' valign='top'>
                        仕入金額<br />
                        {enFormat(row.survey_cost_parking_rent)}<br />
                        {enFormat(row.survey_cost_key_money)}<br />
                        {enFormat(row.survey_cost_commission)}<br />
                        {enFormat(row.survey_cost_other)}<br />
                        {enFormat(row.survey_cost_security_deposit)}<br />
                        {enFormat(row.survey_cost_total_amt)}<br />
                        <br />
                        <br />
                      </td>
                      <td align='right' valign='top'>
                        見積金額<br />
                        {enFormat(row.survey_parking_rent)}<br />
                        {enFormat(row.survey_key_money)}<br />
                        {enFormat(row.survey_commission_discount_amt)}<br />
                        {enFormat(row.estimate_detail_amt + row.estimate_detail_amt_ex)}<br />
                        {enFormat(row.survey_cost_security_deposit)}<br />
                        {enFormat(row.survey_total_amt)}<br />
                        {enFormat(profit_amt)}<br />
                        {profit_rate}%<br />
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  顧客メモ
                  <Input
                    style={{
                      height: "120px",
                      maxHeight: "120px",
                      maxWidth: "90%",
                      margin: "10px"
                    }}
                    type={"textarea"}
                    value={row.order_memo || ""}
                    onClick={() => { addMemo({ row }, true); }}
                  />
                </td>
                <td>
                  仕入先メモ
                  <Input
                    style={{
                      height: "120px",
                      maxHeight: "120px",
                      maxWidth: "90%",
                      margin: "10px"
                    }}
                    type={"textarea"}
                    value={row.supplier_memo || ""}
                    onClick={() => { addMemo({ row }, false); }}
                  />
                  {/* 別のコンポーネントからdocument.getElementById(ulid).click();を実行してこのコンポーネントのデータを再取得させる*/}
                  <input type="hidden" id={row.ulid} onClick={() => {resetData()}} />
                </td>
              </tr>
            </>
          })
          }
        </tbody>
      </table>
    </div>
  </>
}

